import { addressValidations } from '../../utils/validations'

const validate = ({ contactAddress, differentContactAddress, permanentAddress }: any) => ({
  permanentAddress: addressValidations(permanentAddress),
  contactAddress: differentContactAddress ? addressValidations(contactAddress) : {},
})

export default validate
